// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { getItem } from '@automator/builder/services/item';

// Import recipe builder utils
import { builderFetch } from '@automator/builder/utils';

/**
 * Removes the schedule
 *
 * @param {Number} itemID The item ID
 * @param {("delay"|"schedule")} mode The mode
 * @return {Promise} The apiFetch promise
 */
const removeSchedule = async ( itemID, mode ) => {
	// Event name
	const eventName = 'uap/builder/core/item/action-schedule/remove-schedule';

	// Get the action
	const action = getItem( 'action', itemID );

	// If the item is not define, stop here
	if ( isEmpty( action ) ) {
		throw new Error( `removeSchedule: The action ${ itemID } doesn't exist` );
	}

	// If the mode is not defined, stop here too
	if ( isEmpty( mode ) ) {
		throw new Error( `removeSchedule: mode must be defined` );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'remove_schedule',
		method: 'POST',
		data: {
			recipeId: UncannyAutomator._recipe.recipe_id,
			actionId: itemID
		},
		snackbar: {
			loading: mode === 'delay' ? escapeHTML( __( 'Removing delay', 'uncanny-automator' ) ) : escapeHTML( __( 'Removing schedule date', 'uncanny-automator' ) ),
			success: mode === 'delay' ? escapeHTML( __( 'Delay removed successfully', 'uncanny-automator' ) ) : escapeHTML( __( 'Schedule date removed successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					actionID: itemID
				}
			} ) );
		}

		return response;
	} );
}

export default removeSchedule;
